<template>
  <label class="zt-form-item">
    <span class="form-item__label mr8" v-show="label">{{ label }}</span>
    <span class="form-item__content"><slot></slot></span>
  </label>
</template>

<script>
export default {
  name: 'ZtFormItem',
  props: {
    label: String,
  },
}
</script>

<style lang="scss" scoped>
.zt-form-item {
  display: inline-block;

  .form-item__label {
    display: inline-block;
    white-space: nowrap;
    font-weight: normal;
    font-size: 14px;
  }
  .form-item__content{
    display: inline-block;
  }
}
</style>